<template>
    <div class="dispatcher">
        <div class="head">
            <div class="head-title">{{$t('dispatcher.dispatcherList')}}</div>
            <div class="head-right">
                <div class="example-block">
                    <el-input v-model="searchValue" clearable :placeholder="$t('dispatcher.searchName')" class="inputStyle">
                        <template #append>
                           <div @click="dispatcherQuery">
                             <Search  style="width: 1em; height: 1em;" />
                           </div>
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="dispatcher-box" v-show="dispatcherList.length>=1">
            <div class="dispatcherCard" v-for="(item) in dispatcherList" :key="item.id">
                <div class="dispatcher-left">
                    <img :src="item.face_img">
                </div>
                <div class="dispatcher-right">
                    <h6>{{ item.name }}</h6>
                    <p>{{$t('account.addtimes')}}：<span>{{ item.create_time ? item.create_time : '-' }}</span></p>
                </div>
            </div>
            <el-pagination
        background
        v-show="total > 0"
        :page-size="params.pageSize"
        :page-sizes="[12, 24, 48]"
        :total="total"
        :current-page="params.page"
        @current-change="changePage"
        @size-change="sizechangePage"
        layout="total, prev, pager, next, sizes"
        class="pagination"
      />
        </div>
        <div class="noRobotData" v-show="dispatcherList.length<=0">
        <img src="../../assets/images/public/notData.png">
        <span>{{ $t('system.noData') }}</span>
      </div>
        <!-- <paging v-if="total > 12" :totalCompone="total" @changePage="changePage"></paging> -->
        
    </div>
</template>

<script lang="ts">
import { deliveryQuery } from '@/apis/dispatcher'
import { reactive, ref, toRefs, defineComponent, onMounted, watch, onBeforeUnmount, } from "vue";
import formatTime from "../../utils/format"
import paging from '@/components/paging/paging.vue'

export default defineComponent({
    components:{
        paging
    },
    setup() {
        const state = reactive({
            searchValue: '',
            imageUrl: '',
            total: 0,
            dispatcherList: [

            ] as any,
            params: {
                    pageSize: 12,
                    page: 1,
                    limit: true
                } as any,
            dispatcherQuery() {
                // console.log(state.searchValue)
                    state.params.search = state.searchValue
                deliveryQuery(state.params).then((res: any) => {
                    console.log('配送员查询', res)
                    state.total = res.data.total
                    if (res.data.list != null) {
                        res.data.list.forEach((item: any) => {
                            item.face_img = `data:image/jpg;base64,${item.face_img}`
                            // item.face_img = str.replace(/[\r\n]/g, '')
                            // item.face_img = require(`${item.face_img}`)
                            item.create_time = formatTime("YYYY-mm-dd", item.create_time)
                        })
                    }
                    state.dispatcherList = res.data.list?res.data.list:[]
                })
            },
            sizechangePage(val:number) {
                state.params.page = 1
                state.params.pageSize = val
                state.dispatcherQuery()
            },
            // 页码切换
            changePage(val:number){
                state.params.page = val
                state.dispatcherQuery()
            },
            init() {
                state.dispatcherQuery()
            }
        })

        onMounted(() => {
            state.init()
        })

        return {
            ...toRefs(state)
        }
    }
})
</script>
<style lang="scss">
.dispatcher{
 .el-input-group__append{
    cursor: pointer;
    padding: 0;
    width:20%;
    text-align: center;
 }
}

</style>
<style lang="scss" scoped>
h6,
p {
    padding: 0;
    margin: 0;
}

.dispatcher {
    width: 97.5%;
    min-height: 750px;
    padding: 20px 0 20px 20px;
    margin: 20px;
    background: #FFFFFF;
      .noRobotData {
    height: 700px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
      margin-top: 10px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.25);
    }
  }

    .head {
        margin-bottom: 40px;

        .head-title {
            float: left;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            line-height: 20px;
        }

        .head-right {
            float: right;
            display: flex;
            align-items: center;
            margin-right: 20px;

            .addLadderControl {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 40px;
                width: 102px;
                height: 32px;
                background: #1890FF;
                border-radius: 2px;

                span {
                    height: 20px;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 20px;
                }
            }
        }
    }
}

.dispatcher-box {
    width: 100%;
    height: 695px;
    background: #FFFFFF;

}

.dispatcherCard {
    cursor: pointer;
    position: relative;
    margin: 20px 23px 0 2px;
    display: inline-block;
    width: 337px;
    height: 200px;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    padding: 2px;

    .dispatcher-left {
        position: relative;
        display: inline-block;

        img {
            height: 200px;

        }
    }

    .dispatcher-right {
        display: inline-block;
        position: relative;
        top: -73px;
        left: 20px;

        h6 {
            margin-bottom: 30px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 20px;
        }

        p {
            height: 18px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 18px;
            margin-bottom: 5px;

            img {
                position: relative;
                top: 3px;
                margin-left: 10px;
            }
        }
    }
}
.dispatcherCard:hover{
    padding: 0;
    border: 2px solid #1890FF;
   }
</style>
